import {
  IItem,
  IItemOption,
  IItemOptionModifier,
  IItemOptionModifierWithQuantity,
} from '@rbi-ctg/menu';

export interface IModifierSelections {
  [modifierOptionKey: string]: IItemOptionModifierWithQuantity;
}

export interface IRadioCheckListOption {
  label?: string;
  labelSuffix?: string;
  value: string;
}

export interface IModifierListItemProps {
  aspectRatio?: number;
  badgeContent?: string;
  content: IItemOption | IItemOptionModifier;
  selectedOption?: IItemOptionModifier | string;
  onListItemPress?: (value?: string) => any | void;
  options?: IRadioCheckListOption[];
  onOptionPress?: (val: any) => void;
  isSelected?: boolean;
  // @todo: leaving these one for now, this will be removed
  controls?: any;
  isListItemClickable?: any;
  onListItemClick?: any;
}

export interface IModifierTypeUIProps {
  modifier: IItemOption;
  selectedItem: IItem;
  selections: IModifierSelections;
  onSelectionsChange: (option: IModifierSelections) => void;
}

export interface IModifierData {
  modifier: IItemOption;
  selections: IModifierSelections;
}

export interface IModifierProps extends IModifierData {
  onSelectionsChange: (selections: IModifierSelections) => void;
  selectedItem: IItem;
}
